import { render } from "./CreateOffer.vue?vue&type=template&id=3e81f3ae"
import script from "./CreateOffer.vue?vue&type=script&lang=js"
export * from "./CreateOffer.vue?vue&type=script&lang=js"
script.render = render

export default script